import axiosInstance from "@/utils/AxiosInstance";

const BASE_API = '/permissions';

const getAllPermissions = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/`);
}

const getNavigationMenu = async (): Promise<any> => {
    return await axiosInstance.get(`${BASE_API}/menu`);
}

export default {
    getAllPermissions,
    getNavigationMenu
}